export default {
  error_occurred_when_loading_data:
    'Nastala chyba při načítání dat, zkuste to prosím později',
  error_occurred_somewhere: 'Někde nastala chyba',
  logged_successfully: 'Přihlášení proběhlo úspešně',
  bad_credentials: 'Špatná kombinace uživatelského jména a hesla.',
  me_loading_error: 'Nastala chyba při načítání vašeho účtu',
  me_loading: 'Načítání informací o vašem účtu',
  logged_out_successfully: 'Odhlášení proběhlo úspěšně',
  added_to_my_selection_successfully: 'Úspěšně přidáno do Vašeho výběru',
  removed_from_my_selection_successfully: 'Úspěšně smazáno z Vašeho výběru',
  pending_adding_to_my_selection: 'Probíhá přidávání do Vašeho výběru',
  pending_remove_from_my_selection: 'Probíhá odebírání z Vašeho výběru',
  no_record_found: 'Nebyl nalezen žádný záznam',
  illustration_not_found: 'Ilustrace nebyla nalezena',
  you_were_logged_out: 'Vaše relace vypršela, přihlašte se prosím znovu',
  copied: 'Zkopírováno',
  pending_view_change_in_my_selection:
    'Probíhá změna viditelnosti záznamu v Miradoru',
  changed_view_in_my_selection_successfully:
    'Změna viditelnosti v Miradoru proběhla úspěšně',
  loading: 'Načítání...',
}
